import React from "react";
import { connect } from "react-redux";
import { getBrand } from "../brand/brand-selectors";

function BackgroundVideo({ brand }) {
  return brand.backGroundVideo ? (
    <video
      className="Background App__BackgroundVideo"
      muted
      autoPlay
      loop
      src={brand.backGroundVideo}
    />
  ) : null;
}
BackgroundVideo = connect(state => ({
  brand: getBrand(state)
}))(BackgroundVideo);

export default BackgroundVideo;



// WEBPACK FOOTER //
// ./src/modules/root/app-background-video.js